import { getGlobalSearchManager } from '../../packages/global-search'
import type { ShellHook } from './models'

export const initializeGlobalSearch: ShellHook = () => getGlobalSearchManager().initialize()
